import { Box } from "@mui/material";
import { useWebhooks } from "api/webhooks";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { WebhookForm } from "./WebhookForm";
import { useStyles } from "./WebhookForm.styles";

export function EditWebhook() {
  const classes = useStyles();
  const { message } = useMessage();
  const { id: webhookID } = useParams<{ id: string }>();
  const { useWebhookData } = useWebhooks();
  const { data: webhookData } = useWebhookData(webhookID as string);

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "activeWebhooks" }),
      path: links.webhookList,
    },
  };

  return (
    <>
      <TopHeader
        title={`${message({ id: "edit" })} "${webhookData?.eventName}"`}
        clearLink={links.webhookList}
        breadcrumbs={breadcrumbs}
      />
      <Box className={classes.formContainer}>
        <WebhookForm
          editMode
          initialValues={webhookData}
          data-test-id="edit-webhook"
        />
      </Box>
    </>
  );
}
